module.exports = __webpack_public_path__ + "img/5.340f587f.png";